import React from 'react'
import { Button, Select } from 'antd'
import { useTranslation } from 'next-i18next'
import { useAppSelector } from 'src/app/hooks'
import { CustomTextInput, CustomText, CustomSelect } from 'src/components'
import { createIntegrationSelector, userIsApiPremiumSelector } from 'src/features'

const DevelopersIntegrationForm: React.FC = () => {
  const { t } = useTranslation()
  const { loading } = useAppSelector(createIntegrationSelector)
  const businessTypeIsVisible = useAppSelector(userIsApiPremiumSelector)

  return <>
    {/* Integration Name */}
    <CustomText label={t('developers.IntegrationName')} />
    <CustomTextInput
      name='integration_code'
      required={true}
      placeholder={t('footPrint.FootPrintNamePlaceholder')}
    />
    {/* Integratio Type */}
    {businessTypeIsVisible && <>
      <CustomText label={t('developers.IntegrationType')} />
      <CustomSelect
        name='type'
        placeholder={t('developers.IntegrationTypePlaceholder')}
        required
      >
        <Select.Option value='PREPURCHASE'>{t('developers.PrePurchaseType')}</Select.Option>
        <Select.Option value='WHITELABEL'>{t('developers.IntegrationTypeLabels.WHITELABEL')}</Select.Option>
      </CustomSelect>
    </>}
    {/* Submit Button */}
    <Button
      block
      size='large'
      type='primary'
      htmlType='submit'
      loading={loading}
      className='radius-100'
    >
      {loading ? t('developers.Creating') : t('general.Create')}
    </Button>
  </>
}

export default DevelopersIntegrationForm
